import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { PageShell } from '@/components/generals/page-shell'
import { ClosingCta } from '@/components/generals/closing-cta'
import { AboutMasthead } from '@/components/about/about-masthead'
import { AboutStatement } from '@/components/about/about-statement'
import { AboutPlates } from '@/components/about/about-plates'
import { AboutIndex } from '@/components/about/about-index'

const About: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='About'
                description='Morph is a two-person landscape and aerial photographic practice working out of Bermondsey, London, since 2014.'
                ogImage='/images/about/portrait.png'
            />

            <PageShell>
                <AboutMasthead />
                <AboutStatement />
                <AboutPlates />
                <AboutIndex />

                <ClosingCta
                    label='(06) — Next'
                    title='Start a project'
                    href='/contact'
                    action='Contact the studio'
                    note='Commissions, print sales, licensing and exhibition loans. Tell us where you want us to stand and we will tell you honestly what it takes to get the picture.'
                />
            </PageShell>
        </>
    )
}

export default About
